import { render, staticRenderFns } from "./FormBaja.vue?vue&type=template&id=52e61d44&"
import script from "./FormBaja.vue?vue&type=script&lang=js&"
export * from "./FormBaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports